import type { JSONContent } from "@tiptap/core";
import { boxIal } from "../chapter_markdown/callout";

// The classes a `:::` box takes in the reader (callout.ts maps them to Portuguese names), and their label keys.
export const BOX_KINDS = [
	{ cls: "roll", label: "box_roll" },
	{ cls: "highlighted", label: "box_highlighted" },
	{ cls: "lesson", label: "box_lesson" },
	{ cls: "readme", label: "box_readme" },
	{ cls: "rule", label: "box_rule" },
	{ cls: "note-arkhi", label: "box_note_arkhi" },
	{ cls: "example-arkhi", label: "box_example_arkhi" },
	{ cls: "text-right", label: "box_text_right" },
	{ cls: "border-box", label: "box_border_box" },
];

// The class list of a block's `{: class="…"}`, for styling any quote the way the reader does.
export const classesOf = (ial: string | null | undefined) => /\bclass="([^"]*)"/.exec(ial ?? "")?.[1] ?? "";

// Only a box the serializer writes as `:::` has a kind to change.
export const isBox = (ial: string | null | undefined) => Boolean(ial && boxIal(ial));

export const withKind = (ial: string | null | undefined, cls: string) => {
	const style = ial ? boxIal(ial)?.[2] : undefined;
	return `{: class="${cls}"${style ? ` ${style}` : ""}}`;
};

export const newBox = (cls: string): JSONContent => ({ type: "blockquote", attrs: { ial: withKind(null, cls) }, content: [{ type: "paragraph" }] });
